import React, { useEffect, useState } from 'react'
import Sidebar from '../../../components/sidebar/sidebar'
import Navbar from "../../../components/navbar"
import { AddNewButton } from '../../../components/buttoncomponents'
import Informations_form_two from '../common/informations_form_two'
import Listing_two from '../common/listing_two'
import { Card } from 'react-bootstrap'
import axios from 'axios'
import * as CONFIG from "../../../helpers/config"
import { useMsal } from "@azure/msal-react";

export default function Index() {
    const { instance } = useMsal();
    useEffect(()=>{
        if (localStorage.getItem('AuthToken') == null) {
            console.log(localStorage.getItem('AuthToken'))
            window.location.href= "/"
        }
        else{
            console.log('inside')
        }
    })
    const [isFirst, setIsFirst] = useState(true);
    const [isAddTrace, setIsAddTrace] = useState(false);
    const [productTrace, setProductTrace] = useState([]);
    const [isEdit, setIsEdit] = useState(false)
    const [selectedData, setSelectedData] = useState([]);
    const [error, setError] = useState(false);
    const [errorData, setErrorData] = useState('');
    const addTrace = ()=>{
        setIsAddTrace(!isAddTrace);
    }
    
    useEffect(()=>{
       if(isFirst){
            getlist()
       }
       
       setIsFirst(false)
    })

    const getlist = ()=>{
        const json_list = {
            "instanceID" : CONFIG.PMSInstanceID,
            "accountSubscriptionID" : CONFIG.AccountSubscriptionID,
            "created_User" : CONFIG.LoginID
        }
        axios.post(CONFIG.TMS_SERVER_URL+CONFIG.GET_PRODUCT_TRACE, json_list, { headers: {"Authorization": `Bearer ${CONFIG.AuthToken}`,  "Ocp-Apim-Subscription-Key": CONFIG.API_KEY } })
        .then((res) => {
            console.log(res.data.result)
            setProductTrace(res.data.result);
        }).catch((error)=>{
            if(error.response.status == 401){
                localStorage.clear();
                instance.logoutRedirect({
                  postLogoutRedirectUri: "/",
                });
            }
        })  
    }

    const saveCategory = (data)=>{
        console.log(data)
        const json_list = isEdit?{
            "instanceID" : CONFIG.PMSInstanceID,
            "accountSubscriptionID" : CONFIG.AccountSubscriptionID,
            "created_User" : CONFIG.LoginID,
            "Modified_User" : CONFIG.LoginID,
            "productTraceElementID": data.id,
            "productTraceElementName": data.data1,
            'productTraceElementUnit': "%"
        }
        :
        {
            "instanceID" : CONFIG.PMSInstanceID,
            "accountSubscriptionID" : CONFIG.AccountSubscriptionID,
            "productTraceElementName" : data.data1,
            'productTraceElementUnit': "%",
            "created_User" : CONFIG.LoginID
        }
       if(!isEdit){
            axios.post(CONFIG.TMS_SERVER_URL+CONFIG.ADD_PRODUCT_TRACE, json_list, { headers: {"Authorization": `Bearer ${CONFIG.AuthToken}`,  "Ocp-Apim-Subscription-Key": CONFIG.API_KEY } })
            .then((res) => {
                if(res.data.responseCode == '303002'){
                    setError(true)
                    setErrorData('Trace element already exists');
                }
                else if(res.data.responseCode == '303001'){
                    setError(true)
                    setErrorData('Trace element invalid. Please try again!');
                }
                else{
                    setError(false)
                }
                setIsEdit(false)
                getlist()
            }).catch((error)=>{
                if(error.response.status == 401){
                    localStorage.clear();
                    instance.logoutRedirect({
                      postLogoutRedirectUri: "/",
                    });
                }
            })  
       }
       else{
        console.log('inside');
        axios.post(CONFIG.TMS_SERVER_URL+CONFIG.EDIT_PRODUCT_TRACE, json_list, { headers: {"Authorization": `Bearer ${CONFIG.AuthToken}`,  "Ocp-Apim-Subscription-Key": CONFIG.API_KEY } })
        .then((res) => {
            if(res.data.responseCode == '303002'){
                setError(true)
                setErrorData('Trace element already exists');
            }
            else if(res.data.responseCode == '303001'){
                setError(true)
                setErrorData('Trace element invalid. Please try again!');
            }
            else{
                setError(false)
            }
            setIsEdit(false)
            getlist()
        }).catch((error)=>{
            if(error.response.status == 401){
                localStorage.clear();
                instance.logoutRedirect({
                  postLogoutRedirectUri: "/",
                });
            }
        })  
       }
    }

    const edit = (e)=>{
        const id = e.target.id;
        let data = productTrace.filter(x=> x.productTraceElementID == id);
        setSelectedData(data);
        setIsEdit(true)
        addTrace();
    }
    const deletedata = (e)=>{
        const id = parseInt(e.target.id);
        const json_list = {
            "instanceID" : CONFIG.PMSInstanceID,
            "accountSubscriptionID" : CONFIG.AccountSubscriptionID,
            "created_User" : CONFIG.LoginID,
            "id" : id
        }
        axios.post(CONFIG.TMS_SERVER_URL+CONFIG.DELETE_PRODUCT_TRACE, json_list, { headers: {"Authorization": `Bearer ${CONFIG.AuthToken}`,  "Ocp-Apim-Subscription-Key": CONFIG.API_KEY } })
        .then((res) => {
            getlist()
        }).catch((error)=>{
            if(error.response.status == 401){
                localStorage.clear();
                instance.logoutRedirect({
                  postLogoutRedirectUri: "/",
                });
            }
        })  
    }
    return (
        <div className='main-wrapper inner-wrapper d-flex'>
                
                <Sidebar id='4.7' isOpenid={4}/>
                <div className='width-100'>
                    <Navbar/>
                    <div className='d-flex inner-page-header justify-content-between'>
                        <div className='d-flex'>
                            <img src='assets/images/pageicons/productsicon.svg' className='inner-page-titleicon img-fluid'/><span className='font-16 font-weight-600 color-707895 d-flex align-items-center pl-10'>TRACE ELEMENTS</span>
                        </div>
                    </div>
                    <div className='inner-page-content'>
                        <div className=' br-8 py-3'>
                                <Card className='p-2-rem col-md-7'>
                                    <div className='d-flex justify-content-end'>
                                        <AddNewButton value='Add New Trace Element' class='bg-white' clickEvent={addTrace} />
                                    </div>
                                    {isAddTrace && 
                                        <Informations_form_two 
                                            isOpen={isAddTrace} 
                                            title={isEdit?'EDIT TRACE ELEMENT':'ADD NEW TRACE ELEMENT'} 
                                            buttontext ={isEdit?'Edit Trace Element':'Add Trace Element'}
                                            inputLabel1 = 'Trace Element*'
                                            inputLabel2 = 'Unit'
                                            onSave={saveCategory}
                                            toggle={addTrace}
                                            id={isEdit?selectedData[0].productTraceElementID:''}
                                            name={isEdit?selectedData[0].productTraceElementName:''}
                                            unit={isEdit?selectedData[0].productTraceElementUnit:''}
                                            isEdit={isEdit}
                                        />
                                    }
                                    {error &&
                                        <div className='input_error'>{errorData}</div>
                                    }
                                    <table className="table pcustom  table-text mt-1-rem">
                                        <thead>
                                            <tr className='bg-F8F9FA font-weight-500 color-707895'>
                                                <th>Trace Elements</th>
                                                <th>Trace Unit</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {productTrace.map((cat,k)=>(
                                                <Listing_two key={k} id={cat.productTraceElementID} name={cat.productTraceElementName} unit={cat.productTraceElementUnit} edit={edit} delete={deletedata}/>
                                            ))}
                                        </tbody>
                                    </table>
                                </Card>
                        </div>
                    </div>
                </div>
                

        </div>
    )
}
